/**
 * Converts meters to inches.
 * @param {Number} m
 */
const convertMetersToInches = (m) => m * 39.37;

export default convertMetersToInches;
